import React from "react";

interface CompanyStatusBadgeProps {
  status: "active" | "inactive";
}

const CompanyStatusBadge: React.FC<CompanyStatusBadgeProps> = ({ status }) => {
  const styles = {
    active: "bg-green-100 text-green-800",
    inactive: "bg-red-100 text-red-800",
  };

  return (
    <span
      className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${styles[status]}`}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default CompanyStatusBadge;
